window.isVisible = (element) => {
	return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

window.isInViewport = (element) => {
	const e = element.getBoundingClientRect();
	return (window.innerWidth >= e.left && 0 < e.right && window.innerHeight >= e.top && 0 < e.bottom);
}


let $exp = (function(){
	let timer = null;
	let tracked = {};
	let queue = [];

	return {
		track: function(name, callback) {
			if (!name)
				return 0;

			let tracking = tracked[name];
			let variant = this.variant(name);

			if (tracking) {
				if (callback) {
					if (tracking.pending) {
						tracking.callbacks.push(callback);
					} else {
						callback(variant);
					}
				}
				return variant;
			} else {
				tracking = {};
				tracking.callbacks = [];
				tracking.pending = true;
				if (typeof callback === "function")
					tracking.callbacks.push(callback);
				tracked[name] = tracking;
			}

			queue.push(name);

			timer && clearTimeout(timer);
			timer = setTimeout(function() {
				$.ajax({
					type: "GET",
					url: "/track/" + queue.join(','),
					async: true,
				}).done(function() {
					tracking.pending = false;
					for (var i in tracking.callbacks) {
						var callback = tracking.callbacks[i];
						callback(variant);
					}
				});
				queue = [];
			}, 250);

			return variant;
		},

		variant: function(name) {
			if(typeof variants_ === 'undefined')
				return 0;
			return variants_[name] || 0;
		}
	};
})();


document.addEventListener('DOMContentLoaded', _ => {
	window.setTimeout(_ => {
		let trackOnViews = [...document.querySelectorAll('[data-exp-track-on-view]')];
		if (trackOnViews.length) {
			const onViewEvents = 'scroll resize click mouseup'.split(' ');

			let trackOnView = _ => {
				for (var i = 0; i < trackOnViews.length; ++i) {
					let el = trackOnViews[i];
					if (isVisible(el) && isInViewport(el)) {
						const name = el.dataset.expTrackOnView;
						$exp.track(name);

						trackOnViews.splice(i, 1);
						i--;
					}
				}

				if (trackOnViews.length == 0) {
					onViewEvents.forEach(event => {
						window.removeEventListener(event, trackOnViewEventHandler);
					});
				}
			}

			trackOnView();

			let timer = null;
			let trackOnViewEventHandler = _ => {
				timer && clearTimeout(timer);
				timer = setTimeout(trackOnView, 333);
			};

			onViewEvents.forEach(event => {
				window.addEventListener(event, trackOnViewEventHandler);
			});

			'blur change click dblclick'.split(' ').forEach(event => {
				let trackOnEvent = [...document.querySelectorAll('[data-exp-track-on-' + event + ']')];
				trackOnEvent.forEach(el => {
					el.addEventListener(event, _ => {
						$exp.track(el.dataset['data-exp-track-on' + event]);
					});
				});
			});
		}
	}, 50);
});
